export const initScrollToTop = () => {
    // VARS
    const button = document.querySelector('[data-back-to-top]');

    // LISTENERS
    window.addEventListener('scroll', function() {
        if (window.pageYOffset > 0) {
            button.style.display = 'block';
        } else {
            button.style.display = 'none';
        }
    });

    button.addEventListener('click', function() {
        window.scrollTo({top: 0, behavior: 'smooth'});
    });
}